import * as React from 'react';
import { PackageIcon } from 'lucide-react';
import { Card, CardContent } from 'components/ui/card';
import { Skeleton } from 'components/ui/skeleton';
import { Formatter } from 'utils';

type Props = React.ComponentProps<typeof Card> & {
  icon?: React.ReactNode;
  cardTitle: React.ReactNode;
  tradeName?: string;
  cnpj?: string;
  address?: string;
  loading?: boolean;
}

export const CompanyCard = ({
                              icon,
                              cardTitle,
                              tradeName,
                              cnpj,
                              address,
                              loading,
                              ...props
                            }: Props) => {

  if (loading) return (
    <CardSkeleton cardTitle={cardTitle} icon={icon} />
  );

  return (
    <Card {...props}>
      <CardContent className={'flex flex-col gap-2 pt-6 text-gray-600'}>
        <div className={'flex flex-row items-center gap-2 border-b pb-4 mb-4 border-gray-300'}>
          {icon || <PackageIcon className={'w-6 h-6'} />}
          <p className={'font-GilroySemibold'}>{cardTitle || '---'}</p>
        </div>
        <div className={'flex flex-col gap-4'}>
          <div className={'flex flex-col gap-1'}>
            <p className={'font-GilroySemibold text-[14px]'}>Razão Social</p>
            <p className={'text-xs'}>{tradeName || '---'}</p>
          </div>
          <div className={'flex flex-col gap-1'}>
            <p className={'font-GilroySemibold text-[14px]'}>CNPJ</p>
            <p className={'text-xs'}>{cnpj && Formatter.cnpj(cnpj) || '---'}</p>
          </div>
          <div className={'flex flex-col gap-1'}>
            <p className={'font-GilroySemibold text-[14px]'}>Endereço</p>
            <p className={'text-xs'}>{address || '---'}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

type CardSkeletonProps = React.ComponentProps<typeof Card> & {
  icon?: React.ReactNode;
  cardTitle: React.ReactNode;
}

const CardSkeleton = ({ cardTitle, icon }: CardSkeletonProps) => {
  return (
    <Card>
      <CardContent className={'flex flex-col gap-2 pt-6 text-gray-600'}>
        <div className={'flex flex-row items-center gap-2 border-b pb-4 mb-4 border-gray-300'}>
          {icon || <PackageIcon className={'w-6 h-6'} />}
          <p className={'font-GilroySemibold'}>{cardTitle}</p>
        </div>
        <div className={'flex flex-col gap-4'}>
          <div className={'flex flex-col gap-1'}>
            <p className={'font-GilroySemibold text-[14px]'}>Razão Social</p>
            <Skeleton className={'w-32 h-3'} />
          </div>
          <div className={'flex flex-col gap-1'}>
            <p className={'font-GilroySemibold text-[14px]'}>CNPJ</p>
            <Skeleton className={'w-32 h-3'} />
          </div>
          <div className={'flex flex-col gap-1'}>
            <p className={'font-GilroySemibold text-[14px]'}>Endereço</p>
            <Skeleton className={'w-80 h-3'} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};